import { c as _c } from "react/compiler-runtime";
import { Table } from '@petsmart-ui/sparky';
import React from 'react';
export function createTableConfig<T>(config: TableColumn<T>[]): TableColumn<T>[] {
  return config;
}
export type TableColumn<T> = {
  key: keyof T | string;
  header: string;
  render?: (row: T) => React.ReactNode;
};
export type BaseTableProps<T> = Readonly<{
  data: T[];
  config: TableColumn<T>[];
  caption: string;
  className?: string;
  variant?: 'zebra';
  loading?: boolean;
  loadingContent?: string;
  emptyContent?: string;
  rowKey?: (row: T) => string | number;
}>;
export function BaseTable(t0) {
  const $ = _c(19);
  const {
    data,
    config,
    caption,
    className,
    variant: t1,
    loading: t2,
    loadingContent: t3,
    emptyContent: t4,
    rowKey: t5
  } = t0;
  const variant = t1 === undefined ? "zebra" : t1;
  const loading = t2 === undefined ? false : t2;
  const loadingContent = t3 === undefined ? "Loading..." : t3;
  const emptyContent = t4 === undefined ? "No data available." : t4;
  const rowKey = t5 === undefined ? _temp : t5;
  let t6;
  if ($[0] !== config) {
    t6 = config.map(_temp2);
    $[0] = config;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== t6) {
    t7 = <Table.Header><Table.Row>{t6}</Table.Row></Table.Header>;
    $[2] = t6;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== config || $[5] !== data || $[6] !== emptyContent || $[7] !== loading || $[8] !== loadingContent || $[9] !== rowKey) {
    t8 = renderTableBody(data, config, rowKey, loading, loadingContent, emptyContent);
    $[4] = config;
    $[5] = data;
    $[6] = emptyContent;
    $[7] = loading;
    $[8] = loadingContent;
    $[9] = rowKey;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8) {
    t9 = <Table.Body>{t8}</Table.Body>;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== caption || $[14] !== className || $[15] !== t7 || $[16] !== t9 || $[17] !== variant) {
    t10 = <Table caption={caption} variant={variant} className={className}>{t7}{t9}</Table>;
    $[13] = caption;
    $[14] = className;
    $[15] = t7;
    $[16] = t9;
    $[17] = variant;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}
function _temp2(col) {
  return <Table.Cell key={col.header}>{col.header}</Table.Cell>;
}
function _temp() {
  return "";
}
function renderTableBody<T>(data: T[], config: TableColumn<T>[], rowKey: (row: T) => string | number, loading: boolean, loadingContent: string, emptyContent: string): React.ReactNode {
  if (loading) {
    return <Table.Row>
                <Table.Cell colSpan={config.length}>{loadingContent}</Table.Cell>
            </Table.Row>;
  }
  if (!data || data.length === 0) {
    return <Table.Row>
                <Table.Cell colSpan={5}>{emptyContent}</Table.Cell>
            </Table.Row>;
  }
  return data?.map((row, rowIndex) => <Table.Row key={rowKey ? rowKey(row) : rowIndex}>
            {config.map(col => <Table.Cell key={col.header}>
                    {col.render ? col.render(row) : row[col.key as keyof T] as React.ReactNode}
                </Table.Cell>)}
        </Table.Row>);
}